import React, {useEffect, useState, useContext} from 'react';

import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext'
import { Link } from 'react-router-dom';
const TopBar =(props)=>{
    const { profile } = useContext(ShareContext)

  return  <div className="top-nav">
    <div className="left-top">
        <div className="top">
            <h2>Hi, {profile.lastName} {profile.firstName}</h2>
        </div>
        <p>Your role: {profile.role}</p>
    </div>
    <p className="nav-status">{props.title}</p>
</div>
}
export default TopBar